import axios from "@/repositories/client";

axios.getReservations = (query, pagination, dropdown) => {

  dropdown = dropdown || false;

  let options = {
    params: {
      search: query,
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get('athena/v1/reservations', options)
    .then(response => {
      if(!dropdown)
        return response.data;
      else
        return response.data.data.map(reservation => ({text: reservation.code, value: reservation.id}));
    });
};

axios.getReservation = (reservation) => {
  return axios.get(`athena/v1/reservations/${reservation}`)
    .then(response => {
      return response.data.data;
    });
};

export default axios;